import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import cx from 'classnames';

/**
 * @typedef {object} SkeletonWrapperProps
 * @property {boolean} show
 * @property {boolean} [inheritParentSize]
 * @property {boolean} [inheritChildHeight]
 * @property {string} [skeletonClassName]
 * @property {() => React.ReactNode} [renderComponent]
 * @property {React.ReactNode} [children]
 * @property {boolean} [in]
 */

/**
 * @param {SkeletonWrapperProps} props
 */
const SkeletonWrapper = props => {
  const {
    show,
    renderComponent,
    children,
    skeletonClassName = '',
    inheritParentSize = false,
    inheritChildHeight = false
  } = props;

  if (show) {
    return (
      <Skeleton
        className={cx(skeletonClassName, {
          MuiInherited: inheritParentSize,
          MuiChildHeightInherited: inheritChildHeight
        })}
        animation='wave'
        variant='rectangular'
        data-testid='skeleton-wrapper'>
        {children}
      </Skeleton>
    );
  }

  if (renderComponent) {
    return renderComponent();
  }

  return children;
};

export default SkeletonWrapper;
